import { Dispatch, FC, SetStateAction } from 'react';
import Modal from 'react-modal';

import styled from 'styled-components';
import UserProfileModalWrapper from '../../../shared/your-profile/UserProfileModalWrapper';
import UserProfileModalHeader from './UserProfileModalHeader';

type UserProfileModalProps = {
  modalIsOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

const UserProfileModal: FC<UserProfileModalProps> = ({ modalIsOpen, setIsOpen }) => {
  const onCloseClick = (): void => {
    setIsOpen(false);
  };

  return (
    <Modal
      isOpen={modalIsOpen}
      style={modalStyles}
      contentLabel='Your profile Modal'
      ariaHideApp={false}
    >
      <YourProfileWrapper>
        <UserProfileModalHeader onCloseClick={onCloseClick} />
        <UserProfileModalWrapper modalIsOpen={modalIsOpen} onClose={onCloseClick} />
      </YourProfileWrapper>
    </Modal>
  );
};

export default UserProfileModal;

const YourProfileWrapper = styled.div`
  height: 100%;
`;

const modalStyles = {
  content: {
    top: '60px',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, 0%)',
    width: '80%',
    minHeight: '425px',
    zIndex: 1,
    padding: '0',
    maxWidth: '640px',
    overflow: 'hidden',
  },
};
